import React from 'react'
import { Helmet } from 'react-helmet-async'
import UserGroupLayout from '../../layouts/Users/UserGroupLayout'

const UserGroupPage = (): React.ReactElement => (
  <React.Fragment>
    <Helmet>
      <title>User groups</title>
      <meta name="description" content="User Group page" />
    </Helmet>
    <UserGroupLayout />
  </React.Fragment>
)

export default UserGroupPage
